"use client";

import React from "react";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";
import { styled } from "@mui/system";
import { Skeleton } from "@mui/material";
import {  uid } from "@/utils/fncts";
import { useTranslation } from "react-i18next";
import api from "@/app/lib/api";
import { useQuery } from "@tanstack/react-query";
// import Image from "next/image";

export const Banners = ({
  isMain,
  isCars,
}: {
  isMain: boolean;
  isCars?: boolean;
}) => {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";

  const {
    data: banners,
    isLoading,
    error,
    isSuccess,
    refetch,
  } = useQuery({
    queryKey: ["banners", isMain, isCars],
    queryFn: async () => await api.banners.getAll(false, undefined, isCars),
  });

  if (isLoading)
    return (
      <Skeleton
        variant="rectangular"
        style={{ height: "400px", borderRadius: "20px" }}
      />
    );
  if (error)
    return (
      <div className=" grid center h100a w100 ">
        <img src="/error.png" alt="" className="h70px" />{" "}
        <p className="dark-grey f15">
          {t("error")}: {error?.message}
        </p>
      </div>
    );

  if (isSuccess && Array.isArray(banners) && banners.length != 0)
    return (
      <div>
        {/* {isMain && (
          <>
            <AwesomeSliderStyled>
              {Array.isArray(banners) &&
                (banners as Banner[])?.map((banner) => (
                  <div
                    key={uid()}
                    className={
                      "    p150 mp50  vcenter relative hero-section mc1 gap20"
                    }
                    style={{
                      backgroundColor: banner.background_color
                        ? `${banner.background_color}`
                        : "#e0e0e0ed",
                    }}
                  >
                    <Link href={`/product?id=${banner.product?.id}`}>
                      <img
                        src={`/api/images/uploads/${banner.img?.webImg}`}
                        alt=""
                        className={` banner-img ${
                          currentLocale == "ar" ? "left" : "right"
                        } `}
                      />
                    </Link>
                    <div>
                      <p className="f20">
                        {availableName(banner?.sub_title, currentLocale)}
                      </p>
                      <h2 className="f40 mf30 fw800 break-word">
                        {" "}
                        {availableName(banner?.title, currentLocale)}{" "}
                      </h2>
                      <h1 className="f80 mf40 fw800 uppercase break-word">
                        {" "}
                        {availableName(banner?.big_title, currentLocale)}{" "}
                      </h1>

                      <Link href={`/product?id=${banner.product?.id}`}>
                        <button
                          className="primary-button rounded"
                          onClick={() => {
                            updateBannerViews(banner);
                          }}
                        >
                          {t("getStarted")}
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
            </AwesomeSliderStyled>

            <br className="mobile-only" />
          </>
        )} */}

        {/* {!isMain && ( */}
        <>
          <div
            className="web-only"
            style={{ maxWidth: "1800px", margin: "0 auto" }}
          >
            <AwesomeSliderStyled>
              {banners.map((banner) => (
                <div
                  key={uid()}
                  data-src={`/api/images/uploads/${banner.img?.webImg}`}
                ></div>
              ))}
            </AwesomeSliderStyled>
          </div>
          <div className="mobile-only">
            <AwesomeSliderStyled>
              {Object.values(banners).map((banner) => (
                <div
                  key={uid()}
                  data-src={
                    banner.img?.mobileImg
                      ? `/api/images/uploads/${banner.img?.mobileImg}`
                      : `/api/images/uploads/${banner.img?.webImg}`
                  }
                ></div>
              ))}
            </AwesomeSliderStyled>
          </div>
        </>
        {/* )} */}
      </div>
    );
};

const AwesomeSliderStyled = styled(AwesomeSlider)`
  .awssld__content > img,
  .awssld__content > video {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0px !important;
    overflow: hidden !important;
    object-fit: cover !important;
  }

  .awssld__wrapper {
    width: 100%;
    aspect-ratio: 2.8 / 1 !important;
    border-radius: 0px !important;
    overflow: hidden !important;
  }

  .awssld__content,
  .awssld__box,
  .awssld__wrapper,
  .awssld .awssld--organic-arrows {
    border-radius: 0px;
    background-color: #ffffffed;
    border-radius: 0px !important;
    overflow: hidden !important;
  }
  .awssld__bullets button {
    width: 10px !important;
    height: 10px !important;
    display: none !important;
  }
  .awssld__bullets {
    bottom: -30px !important;
  }
  @media screen and (max-width: 800px) {
    .awssld__wrapper {
      border-radius: 20px !important;
      width: 100%;
      aspect-ratio: 1 / 1 !important;
    }
  }
`;
